export type ProblemArea = "payroll" | "hrtech" | "both";

export type Problem = {
  text: string;
  mode: "Rescue" | "Implement" | "Optimize" | "Operate";
  area: ProblemArea;
  onHome?: boolean;
};

export const problems: Problem[] = [
  { text: "Your payroll person just quit.", mode: "Rescue", area: "payroll", onHome: true },
  { text: "Payroll is due and no one knows how to run it.", mode: "Rescue", area: "payroll", onHome: true },
  { text: "Your HRIS implementation is going sideways.", mode: "Rescue", area: "hrtech", onHome: true },
  { text: "The implementation went live, but the configuration isn’t right.", mode: "Optimize", area: "hrtech", onHome: true },
  { text: "You think your payroll or HRIS setup is wrong.", mode: "Optimize", area: "both", onHome: true },
  { text: "Your team is doing too much manually.", mode: "Optimize", area: "both", onHome: true },
  { text: "You’re changing payroll or HRIS vendors.", mode: "Implement", area: "both", onHome: true },
  { text: "Your payroll provider can’t solve the underlying problem.", mode: "Rescue", area: "payroll" },
  { text: "Nobody has documented how payroll actually works.", mode: "Optimize", area: "payroll" },
  { text: "Your HR technology technically works, but your team hates using it.", mode: "Optimize", area: "hrtech" },
  { text: "Tax filings or registrations have gone wrong.", mode: "Rescue", area: "payroll" },
  { text: "You need someone to run payroll, reliably, every cycle.", mode: "Operate", area: "payroll" },
  { text: "No one owns the system now that the implementation team is gone.", mode: "Operate", area: "hrtech", onHome: true },
];
